import {useInitializeEntityFlagsStore} from './EntityFeatureFlagStore';
import {useInitializeLinePlotDynamicConfigStore} from './LinePlotDynamicConfigStore';
import {useInitializeLinePlotFlagsStore} from './LinePlotFlagsStore';
import {useInitializeViewerFlagsStore} from './ViewerFeatureFlagStore';
import {useInitializeViewerOrgFlagsStore} from './ViewerOrgFeatureFlagStore';

/**
 * Aggregator that hydrates every ramp-flag store for the current route.
 * Mount once per route tree: `MultiRunWorkspaceWithContext.tsx`
 * (workspace/sweep/group) and `ReportPageContainer.tsx` (reports).
 *
 * Prefer the store-backed readers in `./EntityFlagsStore`,
 * `./ViewerFlagsStore`, `./ViewerOrgFlagsStore`, and `./DynamicConfigsStore`
 * over the Apollo primitives in `util/useRampFlag.ts` when the caller sits
 * under a route that mounts this hook and resolves against the route's
 * global `entityName`/viewer/org — one shared cache per page, no per-component
 * Apollo subscriptions. The Apollo primitives remain for non-React call
 * sites and routes that haven't been onboarded here yet.
 */
export function useInitializeRampFlagsStores(): void {
  useInitializeViewerFlagsStore();
  useInitializeViewerOrgFlagsStore();
  useInitializeEntityFlagsStore();
  useInitializeLinePlotDynamicConfigStore();
  useInitializeLinePlotFlagsStore();
}
